import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-3c893894"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = ["src"];
var _hoisted_2 = ["src"];

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("svg", {
    slot: "handle",
    width: "50",
    height: "51",
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [/*#__PURE__*/_createElementVNode("circle", {
    cx: "25",
    cy: "25.1667",
    r: "25",
    fill: "white"
  }), /*#__PURE__*/_createElementVNode("path", {
    d: "M41.4395 26.1863L34.016 32.6809C33.1412 33.4474 31.7708 32.8244 31.7708 31.6612V18.672C31.7705 18.4117 31.8454 18.1568 31.9863 17.9379C32.1272 17.719 32.3282 17.5454 32.5652 17.4378C32.8023 17.3302 33.0653 17.2932 33.3229 17.3313C33.5804 17.3693 33.8215 17.4808 34.0173 17.6524L41.4381 24.1469C41.5836 24.274 41.7002 24.4308 41.78 24.6067C41.8599 24.7825 41.9012 24.9735 41.9012 25.1666C41.9012 25.3598 41.8599 25.5507 41.78 25.7266C41.7002 25.9025 41.5836 26.0592 41.4381 26.1863H41.4395Z",
    fill: "#FFA621"
  }), /*#__PURE__*/_createElementVNode("path", {
    d: "M8.56037 24.147L15.9839 17.6524C16.8587 16.886 18.2291 17.5089 18.2291 18.6721L18.2291 31.6613C18.2293 31.9216 18.1545 32.1765 18.0136 32.3954C17.8727 32.6143 17.6717 32.7879 17.4346 32.8955C17.1976 33.0031 16.9345 33.0401 16.677 33.0021C16.4195 32.964 16.1784 32.8525 15.9826 32.681L8.56173 26.1864C8.41628 26.0593 8.2997 25.9025 8.21983 25.7266C8.13996 25.5508 8.09863 25.3599 8.09863 25.1667C8.09863 24.9735 8.13996 24.7826 8.21983 24.6067C8.2997 24.4309 8.41628 24.2741 8.56173 24.147L8.56037 24.147Z",
    fill: "#FFA621"
  })], -1);
});

var _hoisted_4 = {
  key: 0,
  id: "loading"
};

var _hoisted_5 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "LOADINGComp", -1);
});

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "LOADINGComp", -1);
});

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "LOADINGComp", -1);
});

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "LOADINGComp", -1);
});

var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("h1", null, "LOADINGComp", -1);
});

var _hoisted_10 = [_hoisted_5, _hoisted_6, _hoisted_7, _hoisted_8, _hoisted_9];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ImgComparisonSlider = _resolveComponent("ImgComparisonSlider");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_ImgComparisonSlider, {
    class: "compare-image"
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("img", {
        slot: "first",
        style: {
          "object-fit": "contain",
          "max-width": "100vw",
          "max-height": "100vh"
        },
        src: _ctx.firstImage,
        onLoad: _cache[0] || (_cache[0] = function () {
          return _ctx.loadingComp = false;
        }),
        onError: _cache[1] || (_cache[1] = //@ts-ignore
        function () {
          return _ctx.onError && _ctx.onError.apply(_ctx, arguments);
        })
      }, null, 40, _hoisted_1), _createElementVNode("img", {
        slot: "second",
        style: {
          "object-fit": "contain",
          "max-width": "100vw",
          "max-height": "100vh"
        },
        src: _ctx.secondImage,
        onLoad: _cache[2] || (_cache[2] = function () {
          return _ctx.loadingComp = false;
        }),
        onError: _cache[3] || (_cache[3] = //@ts-ignore
        function () {
          return _ctx.onError && _ctx.onError.apply(_ctx, arguments);
        })
      }, null, 40, _hoisted_2), _hoisted_3];
    }),
    _: 1
  }), _ctx.loadingComp ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_10)) : _createCommentVNode("", true)], 64);
}